import styled from '@emotion/styled';
import { theme } from 'style';

export const StyledDiv = styled.div({
border: '2px solid plum',
});